// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header_3urky","title":"Header_title_3T6qa","menu":"Header_menu_3NKj8","buttonGroup":"Header_buttonGroup_3wJbD","button":"Header_button_LjmjS"};